import React, {
  useEffect,
  useState,
  useReducer,
  useCallback,
  useRef,
} from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "../MasterStyleDashborads/MasterStyleDashboards.scss";
import { showError,  } from "../../../../Helper";
import { MicrosoftToken,  } from "../../../../Services";
import { DateRangePickerComponent } from "../../../../Components/Controls/DateRangePickerComponent/DateRangePickerComponent";
import moment from "moment";
import {
  Inputs,
  SelectComponet,
} from "../../../../Components";
import {
  ActionsButtonsEnum,
  PowerBiEnum,
} from "../../../../Enums";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import {
  ButtonBase,
  ButtonGroup,
} from "@material-ui/core";
import { CellSpinnerBi } from "../CellSpinnerBi/CellSpinnerBi";
import "../AdminMarketing/Navbar.scss";

const parentTranslationPath = "LeadsView";
const translationPath = "";

export const Dehlar = () => {
  const orderFilter = useSelector((state) => state.GlobalOrderFilterReducer);

  const { t } = useTranslation(parentTranslationPath);
  const dispatch = useDispatch();

  const [report, setReport] = useState();
  const [render, setRender] = useState(false);
  const [ShowReport, setShowReport] = useState(false);
  const [ShowReport2, setShowReport2] = useState(false);
  const [DateAppaer, setDateAppaer] = useState(false);
  const [Leadtype, setLeadtype] = useState();
  const [Page, setpage] = useState();
  const [Leadtypestatus, setLeadtypestatus] = useState(true);
  const [OperatorLeadType, setOperatorLeadType] = useState("All");
  const [LeadClass, setLeadClass] = useState();
  const [LeadClassstatus, setLeadClassstatus] = useState(true);
  const [OperatorLeadClass, setOperatorLeadClass] = useState("All");
  const [Leadstatus, setLeadstatus] = useState();
  const [Leadstatusstatus, setLeadstatusstatus] = useState(true);
  const [OperatorLeadstatus, setOperatorLeadstatus] = useState("All");
  const [ContactName, setContactName] = useState();
  const [Namestatus, setNamestatus] = useState(true);
  const [IDstatus, setIDstatus] = useState(true);
  const [OperatoId, setOperatoId] = useState("All");
  const [OperatoName, setOperatoName] = useState("All");
  const [datefilters, setdatefilter] = useState(true);
  const [activeButton, setActiveButton] = useState("One");
  const [MenuButton, setMenuButton] = useState("One");
  const [activeGroupButton, setactiveGroupButton] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isLoading, setIsLoading] = useState({
    referred: false,
    mediaDetails: false,
  });

  const [monthsAgo, setMonthsAgo] = useState(1);

  const currentDate = new Date();
  const countmonth = new Date(
    currentDate.setMonth(currentDate.getMonth() - monthsAgo)
  );
  const [searchedItem, setSearchedItem] = useState("");
  const [idsearchedItem, setIdSearchedItem] = useState("");

  const today = new Date();

  const count = new Date(new Date().setDate(today.getDate() - 7));
  const count2 = new Date(new Date().setDate(today.getDate()));

  const datetimes = moment(count).startOf("day").format("YYYY-MM-DDTHH:mm:ss");
  const datetimes2 = moment(count2).format("YYYY-MM-DDTHH:mm:ss");

  const startDate = datetimes ? new Date(datetimes) : null;
  const endDate = datetimes2 ? new Date(datetimes2) : null;

  const dateRangeDefault = {
    startDate: null,
    endDate: null,
    key: "selection",
  };
 const [dateFilter, setDateFilter] = useState(dateRangeDefault);
  const [data, setdata] = useState([]);
  const [datepicker, setdatepicker] = useState();
  const [vlueapper, setvlueapper] = useState(false);
  const [transactions, settransactions] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const horiSelectorRef = useRef(null);
  const navbarRef = useRef(null);



  useEffect(() => {
    const updateSelector = () => {
      if (navbarRef.current && horiSelectorRef.current) {
        const tabs = navbarRef.current.querySelectorAll("li");
        if (tabs.length > 0) {
          const activeItem = tabs[activeIndex];
          const activeWidth = activeItem.offsetWidth;
          const itemPosLeft = activeItem.offsetLeft;
          horiSelectorRef.current.style.left = `${itemPosLeft}px`;
          horiSelectorRef.current.style.width = `${activeWidth}px`;
        }
      }
    };

 
    updateSelector();
  }, [activeIndex]);

  const handleItemClick = (index) => {
    setActiveIndex(index);
  };



  const GeneralPage = () => {
    handleMenuButtonClick("One");
    setAnchorEl(null);
    Pagenavi("ReportSection6eaf615e56ee0fe885da");
  };
  const reducer = (state, action) => {
    if (action.id !== "edit") return { ...state, [action.id]: action.value };
    if (action.id === "edit") {
      return {
        ...action.value,
      };
    }
    return undefined;
  };

  const [state, setState] = useReducer(reducer, {
    fromDate: null,
    toDate: null,
  });

  useEffect(() => {
    Microsoft(false);
  }, []);

  useEffect(() => {
    const currentState = {
      ...state,
      fromDate:
        (dateFilter.startDate &&
          moment(dateFilter.startDate)
            .startOf("day")
            .format("YYYY-MM-DDTHH:mm:ss")) ||
        null,
      toDate:
        (dateFilter.endDate &&
          moment(dateFilter.endDate)
            .endOf("day")
            .format("YYYY-MM-DDTHH:mm:ss")) ||
        null,
    };
    setState({ value: currentState });
    setdata(currentState);
  }, [dateFilter]);


  const advancedFilter = {
    $schema: "http://powerbi.com/product/schema#advanced",
    target: {
      table: "vw_LeadReport",
      column: datefilters ? "CreatedDate - Copy" : "RoutedDateTime",
    },
    filterType: 0,
    logicalOperator: "And",
    conditions: [
      {
        operator: "GreaterThanOrEqual",
        value: data.fromDate,
      },
      {
        operator: "LessThanOrEqual",
        value: data.toDate,
      },
    ],
    filterType: models.FilterType.AdvancedFilter,
  };




  const FilterLeadType = {
    $schema: "http://powerbi.com/product/schema#basic",
    target: {
      table: "vw_LeadReport",
      column: "LeadsType",
    },
    operator: OperatorLeadType,
    values: [Leadtype],
    filterType: models.FilterType.BasicFilter,
  };
  // const FilterName = {
  //   $schema: "http://powerbi.com/product/schema#basic",
  //   target: {
  //     table: "vw_LeadReport",
  //     column: "Contact Name",
  //   },
  //   operator: OperatoName,
  //   values: [ContactName],
  //   filterType: models.FilterType.BasicFilter,
  // };

const FilterName = {
  $schema: "http://powerbi.com/product/schema#basic",
  target: {
    table: "vw_LeadReport",
    column: "contact_name",
  },
  operator: OperatoName,  
  values: searchedItem ? [searchedItem] : [],
  filterType: models.FilterType.BasicFilter,
};
const FilterId = {
  $schema: "http://powerbi.com/product/schema#basic",
  target: {
    table: "vw_LeadReport",
    column: "LeadID - Copy",
  },
  operator: OperatoId,  
  values: idsearchedItem ? [idsearchedItem] : [],
  filterType: models.FilterType.BasicFilter,
};
  const FilterLeadClass = {
    $schema: "http://powerbi.com/product/schema#basic",
    target: {
      table: "vw_LeadReport",
      column: "LeadClass",
    },
    operator: OperatorLeadClass,
    values: [LeadClass],
    filterType: models.FilterType.BasicFilter,
  };
  const FilterLeadStatus = {
    $schema: "http://powerbi.com/product/schema#basic",
    target: {
      table: "vw_LeadReport",
      column: "StatusId",
    },
    operator: OperatorLeadstatus,
    values: [Leadstatus],
    filterType: models.FilterType.BasicFilter,
  };

  const Microsoft = async (isExpired) => {
    const res = await MicrosoftToken(isExpired);
    if (!(res && res.status && res.status !== 200)) {
      setReport(res);
      setRender(true);
      setShowReport(true);
    } else {
      setReport("");
      showError("Contact Your Bi Admin For Help");
    }
  };

  const onClearedAllFiltersClick = useCallback(() => {
    setDateFilter(dateRangeDefault);
    setLeadtype(0);
    setLeadtypestatus(true);
    setLeadstatus(0);
    setLeadstatusstatus(true);
    setLeadClass(0);
    setLeadClassstatus(true);
    setNamestatus(true);
    setIDstatus(true);
    setIdSearchedItem("");
    setSearchedItem("");
    setdatepicker(0);
    setdatefilter(true);
  }, []);

  const loadBookmarks = async () => {
    const report = window.report;

    if (report) {
      try {
        const bookmarksManager = report.bookmarksManager;
        const fetchedBookmarks = await bookmarksManager.getBookmarks();
        // 
      } catch (error) {
        console.error("Error loading bookmarks:", error);
      }
    }
  };
  const applyBookmark = async (bookmarkName) => {
    const report = window.report;
    if (report) {
      try {
        const bookmarksManager = report.bookmarksManager;
        bookmarksManager.apply(bookmarkName);
        
      } catch (error) {
        console.error("Error applying bookmark:", error);
      }
    }
  };

  const handleButtonClick = (buttonName) => {
    setActiveButton(buttonName);
  };
  const handleMenuButtonClick = (buttonName) => {
    setMenuButton(buttonName);
  };

  const [filterButton, setfilterButton] = useState(false);
  const [clearfilterButton, setclearfilterButton] = useState(false);

  const ChartView = () => {
    applyBookmark("Bookmarkf623b3e01f3ba3e56a23");
    handleButtonClick("One");
    setShowReport2(false);
  };
  const TableView = () => {
    applyBookmark("Bookmark7901e45cf8f0a3712730");
    handleButtonClick("Two");
    setShowReport2(false);
  };

  const FilterHide = () => {
    applyBookmark("Bookmarke8bdfc92671bb77c202b");
    setfilterButton(false);
    setclearfilterButton(false);
  };
  const FilterView = () => {
    applyBookmark("Bookmark4a47b9d51da010b8d401");
    setfilterButton(true);
    setclearfilterButton(true);
  };
  const handleRefreshClick = useCallback(() => {
    window.report
      .refresh()
      .then(() => {
        setShowReport2(false);
      })
      .catch((error) => {});
  }, []);

  const [activeThemeButton, setActiveThemeButton] = useState("blue");
  const handleButtonClick2 = (buttonName) => {
    setActiveThemeButton(buttonName);
  };



  const gettheme = async () => {
    const report = window.report;
    if (report) {
      try {
        report
          .getTheme()
          .then((theme) => {
            
          })
          .catch((error) => {
            console.error(error);
          });
      } catch (error) {
        console.error("Error  theme:", error);
      }
    }
  };

  const [checkedstate, setcheckedState] = useState({
    checkedA: false,
  });

  const [Themeicon, setThemeicon] = useState(false);

 

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);


  const Pagenavi = async (pagestate) => {
    const report = window.report;
    let pages = await report.getPages();

    if (report) {
      try {
        report.setPage(pagestate);

          
      } catch (error) {
        console.error("Error applying:", error);
      }
    }
  };



  

  useEffect(() => {
    if (Leadtypestatus) setOperatorLeadType("All");
    else setOperatorLeadType("In");
    if (LeadClassstatus) setOperatorLeadClass("All");
    else setOperatorLeadClass("In");

    if (Leadstatusstatus) setOperatorLeadstatus("All");
    else setOperatorLeadstatus("In");

    if (Namestatus) setOperatoName("All");
    else setOperatoName("Contains");

    if (IDstatus) setOperatoId("All");
    else setOperatoId("Contains");
  }, [
    Leadtype,
    Leadtypestatus,
    LeadClassstatus,
    LeadClass,
    Leadstatusstatus,
    Namestatus,
    IDstatus,
  ]);

  return (
    <div className="dashboardMain-PowerBIEmbed">
      <CellSpinnerBi
        isActive={!ShowReport}
        blue={activeThemeButton === "blue"}
      />
       <div>
        <div id="navbar-animmenu" ref={navbarRef}>
          <ul className="show-dropdown main-navbar">
            <div className="hori-selector" ref={horiSelectorRef}>
              <div className="left"></div>
              <div className="right"></div>
            </div>
            <li
              className={activeIndex === 0 ? "active" : ""}
              onClick={() => {
                handleItemClick(0);
                GeneralPage();
              }}
            >
              <a>
                <i className={`mdi mdi-account-details-outline mdi-24px `}></i>
                {t(`${translationPath}general-menu`)}
              </a>
            </li>
          
          </ul>
        </div>
      </div>
      <br />
      {render && (
               <div className="mainCardDashboards">
          <div
            className={`dashboardMain  ${
              activeThemeButton === "gold"
                ? "cardDashboardgold"
                : "withoutcardDashboard"
            }`}
          >
      <div>
      <br />
        {DateAppaer && (
          <div>
            <div className="MainFiltersBi">
              <CellSpinnerBi
                isActive={!ShowReport2}
                blue={activeThemeButton === "blue"}
              />
              <div className="selecterbi">
                <div>
<Inputs
  value={searchedItem}
  onInputChanged={(e) => {
    const value = e.target.value;
    setSearchedItem(value);

    if (value === "") {
      setNamestatus(true);   
    } else {
      setNamestatus(false);  
    }
  }}
  idRef="activitiesSearchRef"
  labelClasses="mt-4"
  inputPlaceholder={t(`${translationPath}search-name-dashboard`)}
/>
</div>

             <div className="dashboardInput">
<Inputs
  value={idsearchedItem}
  onInputChanged={(e) => {
    const value = e.target.value;
    setIdSearchedItem(value);

    if (value === "") {
      setIDstatus(true);  
    } else {
      setIDstatus(false);  
    }
  }}
  idRef="activitiesSearchRef"
  labelClasses="mt-4"
  inputPlaceholder={t(`${translationPath}leadid-dashboard`)}
/>
</div>

                <div>
                  <SelectComponet
                    data={[
                      { id: 1, Leadtype: "owner" },
                      { id: 2, Leadtype: "seeker" },
                    ]}
                    emptyItem={{
                      value: 0,
                      text: "select-category",
                      isDisabled: false,
                    }}
                    value={Leadtype || 0}
                    defaultValue={0}
                    valueInput="id"
                    textInput="Leadtype"
                    onSelectChanged={(value) => {
                      switch (value) {
                        case 0:
                          setLeadtypestatus(true);
                          setLeadtype(0);
                          break;
                        default:
                          setLeadtype(value);
                          setLeadtypestatus(false);
                          setShowReport2(false);
                          break;
                      }
                    }}
                    wrapperClasses="w-auto"
                    themeClass="theme-transparent"
                    idRef="Select_Category"
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                    translationPathForData={translationPath}
                  />
                </div>
                <div>
                  <SelectComponet
                    data={[
                      { id: 457, Leadstatus: "open" },
                      { id: 458, Leadstatus: "closed" },
                    ]}
                    emptyItem={{
                      value: 0,
                      text: "select-status",
                      isDisabled: false,
                    }}
                    value={Leadstatus || 0}
                    defaultValue={0}
                    valueInput="id"
                    textInput="Leadstatus"
                    onSelectChanged={(value) => {
                      switch (value) {
                        case 0:
                          setLeadstatusstatus(true);
                          setLeadstatus(0);
                          break;
                        default:
                          setLeadstatus(value);
                          setLeadstatusstatus(false);
                          setShowReport2(false);
                          break;
                      }
                    }}
                    wrapperClasses="w-auto"
                    themeClass="theme-transparent"
                    idRef="Lead_Status"
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                    translationPathForData={translationPath}
                  />
                </div>
                <div>
                  <SelectComponet
                    data={[
                      { id: 1, LeadClass: "seller" },
                      { id: 2, LeadClass: "landlord" },
                      { id: 3, LeadClass: "buyer" },
                      { id: 4, LeadClass: "tenant" },
                    ]}
                    emptyItem={{
                      value: 0,
                      text: "select-lead-type",
                      isDisabled: false,
                    }}
                    value={LeadClass || 0}
                    defaultValue={0}
                    valueInput="id"
                    textInput="LeadClass"
                    onSelectChanged={(value) => {
                      switch (value) {
                        case 0:
                          setLeadClassstatus(true);
                          setLeadClass(0);
                          break;
                        default:
                          setLeadClass(value);
                          setLeadClassstatus(false);
                          setShowReport2(false);
                          break;
                      }
                    }}
                    wrapperClasses="w-auto"
                    themeClass="theme-transparent"
                    idRef="Lead_Type"
                    parentTranslationPath={parentTranslationPath}
                    translationPath={translationPath}
                    translationPathForData={translationPath}
                  />
                </div>
              </div>

              <div className="selecterbi">
           
                  <div>
                    <SelectComponet
                      data={[
                        {
                          id: 1,
                          datepicker: `${translationPath}routed-date-time`,
                        },
                      ]}
                      emptyItem={{
                        value: 0,
                        text: `${translationPath}created-date`,
                        isDisabled: false,
                      }}
                      value={datepicker || 0}
                      defaultValue={0}
                      valueInput="id"
                      textInput="datepicker"
                      onSelectChanged={(value) => {
                        switch (value) {
                          case 0:
                            setdatepicker(0);
                            setdatefilter(true);
                            setShowReport2(false);
                            break;
                          default:
                            setdatepicker(1);
                            setdatefilter(false);
                            setShowReport2(false);
                            break;
                        }
                      }}
                      themeClass="theme-transparent"
                      wrapperClasses="w-auto"
                      idRef="Date_Select"
                      parentTranslationPath={parentTranslationPath}
                      translationPath={translationPath}
                      translationPathForData={translationPath}
                    />
                  </div>
               

                <div>
                   <DateRangePickerComponent
                                      onClearClicked={() => {
                                        setDateFilter({
                                          startDate: null,
                                          endDate: null,
                                          key: "selection",
                                        });
                                      }}
                                      ranges={[dateFilter]}
                                      onDateChanged={(selectedDate) => {
                                        const newStartDate =
                                          selectedDate.selection &&
                                          selectedDate.selection.startDate;
                                        const newEndDate = new Date(
                                          moment(
                                            selectedDate.selection &&
                                              selectedDate.selection.endDate
                                          ).endOf("day")
                                        );
              
                                        setDateFilter({
                                          startDate: newStartDate,
                                          endDate: newEndDate,
                                          key: "selection",
                                        });
                                      }}
                                    />
                </div>
              </div>


              <div className="DashboardFilter">
                <ButtonBase
                  onClick={onClearedAllFiltersClick}
                  id="onClearedAllFiltersref"
                  className="btns theme-solid bg-primary-dark clear-all-btn Dashboardbtn"
                
                >
                  <span className="mdi mdi-filter-remove m-1" />
                </ButtonBase>
              </div>
              <div className="DashboardFilter">
                <ButtonBase
                  onClick={handleRefreshClick}
                  id="onClearedAllFiltersref"
                  className="btns theme-solid bg-primary-dark clear-all-btn Dashboardbtn"
                >
                  <span className="mdi mdi-refresh m-1" />
                </ButtonBase>
              </div>
         
            </div>
          </div>
        )}
      </div>
      <br />

      
            <PowerBIEmbed
              embedConfig={{
                type: "report",
                 id: PowerBiEnum.Dehlar.reportid,
                embedUrl: PowerBiEnum.Dehlar.url,
                accessToken: report,
                filters: [
                  advancedFilter,
                  FilterLeadType,
                  FilterLeadClass,
                  FilterLeadStatus,
                  FilterName,
                  FilterId,
                ],
                settings: {
                  customLayout: {
                    displayOption: models.DisplayOption.FitToWidth,
                  },
                  filterPaneEnabled: false,
                  navContentPaneEnabled: false,
                  panes: {
                    filters: {
                      expanded: false,
                      visible: false,
                    },
                  },
                  background: models.BackgroundType.Transparent,
                },
              }}
              eventHandlers={
                new Map([
                  [
                    "loaded",
                    (event) => {
                    
                      setDateAppaer(true);

                      setShowReport2(false);
                    },
                  ],
                  [
                    "dataSelected",

                    (event) => {
                      setShowReport2(false);
                    },
                  ],

                  [
                    "rendered",
                    (event) => {
                      setShowReport2(true);
                      setRender(true);
                      loadBookmarks();
                      // const start = performance.now();
                       // setTimeout(() => {
                      //   const end = performance.now();
 
                      //   const duration = end - start;
                       // }, 0);
                    },
                  ],

                  [
                    "pageChanged",
                    (event) => {
                      const newPageName = event.detail.newPage.displayName;

                      switch (newPageName) {
                    
                        case "Page 4":
                    
                          setShowReport2(false);
                          setactiveGroupButton(false);

                          setTimeout(() => {
                            scrollToTop();
                          }, 5);
                          break;
                        default:
                         
                          setactiveGroupButton(true);
                          setShowReport2(false);
              
                          setTimeout(() => {
                            scrollToTop();
                          }, 5);
                          break;
                      }
                    },
                  ],

                  [
                    "error",
                    (event) => {
                      const error = event.detail;
                      if (
                        error.detailedMessage === "Get report failed" ||
                        error.detailedMessage ===
                          "Access token has expired, resubmit with a new access token" ||
                        error.detailedMessage ===
                          "Fail to initialize - Could not resolve cluster"
                      ) {
                        Microsoft(true);
                        setRender(false);
                      } else showError(error.detailedMessage);
                    },
                  ],
                ])
              }
              cssClassName={
                ShowReport
                  ? "report-style-class-Show"
                  : "report-style-class-hide"
              }
              getEmbeddedComponent={(embeddedReport) => {
                window.report = embeddedReport;
              }}
            />
          </div>
          </div>
        )}
     
    </div>
  );
};
